import React from "react";
import { StyleView } from "../../../../core/models/entities/StyleView";
import { useExternalDesignContext } from "../contexts/external-design.context";

interface Props {
  views: StyleView[];
  isCurrentView: (v: StyleView) => boolean;
  onStyleViewSelect: (v: StyleView) => void;
  accentColor?: string;
  padding?: string;
}

export function ExternalViewSelector({
  views,
  isCurrentView,
  onStyleViewSelect,
  accentColor,
  padding,
}: Props): JSX.Element {
  return (
    <div
      className="flex gap-x-6 justify-center items-center overflow-x-visible overflow-y-visible"
      style={{ padding: padding || "1.5rem 0" }} // Increased padding to accommodate scaling
    >
      {views.map((v) => {
        const isActive = isCurrentView(v);
        return (
          <div
            className={`cursor-pointer h-24 w-20 flex flex-col justify-center transition-all ease-in-out duration-100 hover:scale-[1.25] ${
              isActive ? "scale-[1.2]" : ""
            }`}
            key={`view-selector_${v.id}`}
            onClick={() => onStyleViewSelect(v)}
          >
            <div className="w-20 h-24 bg-white flex justify-center items-center rounded-sm">
              <img
                src={v.imageUrl}
                className="object-contain h-16"
                alt={v.view}
              />
            </div>
            <div className="text-center text-sm text-gray-700 py-1 truncate">
              {v.view}
            </div>
          </div>
        );
      })}
    </div>
  );
}
